import { supabase_guest } from '../supabase/supabaseClient';

export const uploadFileAndGetUrl = async (file, identifier, folderPath = '', bucketName = 'dana') => {
  try {
    const timestamp = Date.now();
    const ext = file.name.split('.').pop();
    const cleanName = identifier
      .trim()
      .replace(/\s+/g, '_')
      .replace(/[^a-zA-Z0-9_-]/g, '');
    const fileName = `${cleanName}_${timestamp}.${ext}`;
    const fullPath = folderPath ? `${folderPath}/${fileName}` : fileName;

    //2. Upload
    const { error } = await supabase_guest.storage
      .from(bucketName)
      .upload(fullPath, file, {
        contentType: file.type || 'application/octet-stream',
        // upsert: true,
      });

    if (error) throw error;

    // 3. Return URL path dari file
    return fullPath;
  } catch (err) {
    console.error('Upload Error:', {
      message: err?.message,
      statusCode: err?.statusCode,
      error: err?.error,
    });
    return null;
  }
};

const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== 'string') {
        reject(new Error('Unable to convert file to base64'));
        return;
      }
      resolve(result.split(',')[1]);
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });

export const uploadFileToCloudflareR2 = async (
  file,
  identifier,
  folderPath = '',
  bucketName = ''
) => {
  try {
    const timestamp = Date.now();
    const ext = file.name.split('.').pop();
    const cleanName = identifier
      .trim()
      .replace(/\s+/g, '_')
      .replace(/[^a-zA-Z0-9_-]/g, '');
    const fileName = `${cleanName}_${timestamp}.${ext}`;
    const fullPath = folderPath ? `${folderPath}/${fileName}` : fileName;
    const fileBase64 = await fileToBase64(file);

    const payload = {
      action: 'upload',
      objectName: fullPath,
      fileBase64,
      contentType: file.type || 'application/octet-stream',
      bucketName,
    };

    const { data, error } = await supabase_guest.functions.invoke('upload-r2', {
      body: payload,
    });

    if (error || !data?.publicUrl) {
      let errorResponse = null;
      const response = error?.context || error?.response;
      if (response?.json) {
        try {
          errorResponse = await response.clone().json();
        } catch (e) {
          errorResponse = await response.clone().text().catch(() => null);
        }
      } else if (response?.text) {
        errorResponse = await response.text().catch(() => null);
      }

      console.error('Cloudflare R2 upload error:', {
        error,
        errorResponse,
        responseStatus: response?.status,
        responseStatusText: response?.statusText,
        data,
        payloadSummary: {
          objectName: fullPath,
          contentType: payload.contentType,
          bucketName,
          fileSize: file.size,
        },
      });
      return null;
    }

    return {
      publicUrl: data.publicUrl,
      objectName: fullPath,
    };
  } catch (err) {
    console.error('Cloudflare R2 upload failed:', err);
    return null;
  }
};

export const deleteFileFromCloudflareR2 = async (
  objectName,
  bucketName = ''
) => {
  if (!objectName) return false;

  const { data, error } = await supabase_guest.functions.invoke('upload-r2', {
    body: {
      action: 'delete',
      objectName,
      bucketName,
    },
  });

  if (error || !data?.success) {
    console.error('Cloudflare R2 delete error:', error ?? data);
    return false;
  }

  return true;
};

export const getPhotoUrl = async (filename) => {
  if (!filename) return '../assets/photo-profile/profile.png';

  const { data, error } = await supabase_guest
    .storage
    .from('dana')
    .createSignedUrl(filename, 3600); // URL berlaku 3600 detik

  if (error || !data?.signedUrl) {
    console.error('Error getting signed URL:', error?.message);
    return '../assets/photo-profile/profile.png';
  }

  return data.signedUrl;
};

export const deleteFileFromBucket = async (filePath, bucketName = 'uploads') => {
  if (!filePath) return;

  const { error } = await supabase_guest.storage
    .from(bucketName)
    .remove([filePath]);

  if (error) {
    console.error('Delete file error:', error.message);
  }
};
